// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"5e466932","916":"0b637a34"}[chunkId] + ".chunk.css";
};